module.exports = __webpack_public_path__ + "static/remove-last-bottle-fe7cc186d0214b029f0a7c0426af9eee.mp4";